import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/store';
import '../styles/AvatarCreation.css';
import { useQuery } from '@tanstack/react-query';
import { getPropsAvatar, updatePropsAvatar } from '../api/user';
import { DisplayAvatar } from '../components/avatar/DisplayAvatar';
import { attributes, styles, selectedToStyle } from '../components/avatar/PropsAvatar';
import { Avatar } from '../components/avatar/Avatar';
import { SelectionMenu } from '../components/avatar/SelectionMenu';
import { useWindowDimensions } from '../helpers/screenDimensions';
import { WebDisplayMiddle } from '../components/avatar/WebDisplayMiddle';

export const AvatarCreationPage = ({ prop }) => {
    const location = useLocation();
    const history = location.state?.history || [];
    const uid = useAuthStore(store => store.user?.uid);
    const navigate = useNavigate();
    const [avatarColorProps, setAvatarColorProps] = useState(null);
    const [avatarStyleProps, setAvatarStyleProps] = useState(null);
    const [customize, setCustomize] = useState(false);
    const [hidden, setHidden] = useState(false);
    const [counter, setCounter] = useState(0);
    const [hideOnDisplay, setHideOnDisplay] = useState(false);
    const { width } = useWindowDimensions();

    const avatarPropsQuery = useQuery({
        queryKey: ['getPropsAvatar', uid],
        queryFn: () => getPropsAvatar(uid),
        enabled: !(uid === null || uid === undefined),
    });

    useEffect(() => {
        if (avatarPropsQuery.isSuccess && avatarPropsQuery.data !== undefined) {
            setAvatarColorProps(avatarPropsQuery.data.colors);
            setAvatarStyleProps(avatarPropsQuery.data.styles);
        }
    }, [avatarPropsQuery.isSuccess, avatarPropsQuery.data]);

    async function updateAvatar() {
        const newColors = { ...avatarColorProps };
        const newStyles = { ...avatarStyleProps };
        await updatePropsAvatar({ colorProps: newColors, styleProps: newStyles, uid });
        navigate('/profile', { state: { history: [...history, '/avatar'] } }, { replace: true });
    }

    function handleSelectionMenu(e) {
        setCustomize(!customize);
        handleHidden();
    };

    function handleHidden(e) {
        setHidden(!hidden);
    }

    return (
        <div
            className='main flex flex-col justify-center items-center h-100 w-100 overflow-y-hidden'>
            <div className='menu flex items-center justify-center h-12 gap-1 mb-3'>
                <div className='tab-two justify-center items-center flex border-t-2 border-x-2 border-solid border-black w-40 h-20 rounded-t-2xl bg-gradient-to-br from-lightGreen to-white border-b-0'>
                    <h1 className='buddy-text text-base italic'>
                        Virtual Buddy
                    </h1>
                </div>
            </div>
            {avatarColorProps != null && avatarStyleProps != null
                ? (<div className='container-avatar relative flex flex-col justify-center items-center gap-4 w-100'>
                    {!hideOnDisplay
                        ? <DisplayAvatar
                            avatar={
                                <Avatar
                                    {...avatarColorProps}
                                    {...avatarStyleProps}
                                />
                            }
                        />
                        : null
                    }
                    {customize
                        ? width <= 992
                            ? <SelectionMenu
                                avatar={
                                    <Avatar
                                        {...avatarColorProps}
                                        {...avatarStyleProps}
                                    />
                                }
                                setCustomize={setCustomize}
                                setHideOnDisplay={setHideOnDisplay}
                                counter={counter} setCounter={setCounter}
                                props={[avatarStyleProps, setAvatarStyleProps, avatarColorProps, setAvatarColorProps]}
                                setHidden={setHidden} hidden={hidden}
                            />
                            : <WebDisplayMiddle
                                avatar={
                                    <Avatar
                                        {...avatarColorProps}
                                        {...avatarStyleProps}>
                                    </Avatar>
                                }
                                setCustomize={setCustomize}
                                setHideOnDisplay={setHideOnDisplay}
                                counter={counter} setCounter={setCounter}
                                props={[avatarStyleProps, setAvatarStyleProps, avatarColorProps, setAvatarColorProps]}
                                setHidden={setHidden} hidden={hidden}
                            />
                        : null
                    }
                    {!hidden
                        ? <div className='end-buttons flex mx-0 xs:gap-3 sm:gap-3 md:gap-3 lg:gap-3.5 xl:gap-3'>
                            <button
                                className='avatarButton cursor-pointer bg-gradient-to-br from-blueShade1 to-blueShade2 text-center justify-around no-underline whitespace-nowrap outline-none touch-manipulation text-white transition duration-200 select-none font-medium text-base xs:text-sm py-2.5 rounded-xl xs:px-3 sm:px-4 md:px-4 lg:py-3 lg:px-4.5 xl:px-4 xl:py-3'
                                onClick={ () => {
                                    handleSelectionMenu();
                                }}>
                                Customize
                            </button>
                            <button
                                className='avatarButton cursor-pointer bg-gradient-to-br from-blueShade1 to-blueShade2 text-center justify-around no-underline whitespace-nowrap outline-none touch-manipulation text-white transition duration-200 select-none font-medium text-base xs:text-sm py-2.5 rounded-xl xs:px-3 sm:px-4 md:px-4 lg:py-3 lg:px-3 xl:px-4 xl:py-3'
                                onClick={() => {
                                    const newProps = { ...avatarStyleProps };
                                    for (let index = 0; index < attributes.options.length; index++) {
                                        const key = selectedToStyle[index];
                                        const styleIndex =
                                            Math.floor(Math.random() * styles[index].length);
                                        newProps[key] = styles[index][styleIndex];
                                    }
                                    setAvatarStyleProps(newProps);
                                }}>
                                Randomize
                            </button>
                            <button
                                className='avatarButton cursor-pointer bg-gradient-to-br from-blueShade1 to-blueShade2 text-center justify-around no-underline whitespace-nowrap outline-none touch-manipulation text-white transition duration-200 select-none font-medium text-base xs:text-sm py-2.5 rounded-xl xs:px-3 sm:px-4 md:px-4 lg:py-3 lg:px-3 xl:px-4 xl:py-3'
                                onClick={() => {
                                    updateAvatar();
                                }}>
                                Submit
                            </button>
                        </div>
                        : null
                    }
                </div>
                )
                : (<div className='flex justify-center items-center h-100 text-center text-lg'>
                    {' '}
                    Loading...{' '}
                </div>
                )}
        </div>
    );
};
